import type { FlashOptions } from 'features/common/components/Punchup/primitives/layout/PunchupAccordion';

export type FlashFn = (state: 'success' | 'error', opts?: FlashOptions) => void;

/** Calls fn, flashes success on resolve, flashes error and re-throws on reject. */
export const callWithFlash = async <T = void>(
	fn: () => Promise<T>,
	flashFn: FlashFn,
	successOpts: FlashOptions,
	errorOpts: FlashOptions
): Promise<T> => {
	try {
		const result = await fn();
		flashFn('success', successOpts);
		return result;
	} catch (err) {
		flashFn('error', errorOpts);
		throw err;
	}
};
